import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const PasswordReset = () => {
  const [step, setStep] = useState(1); // Step 1: Request reset code, Step 2: Enter reset code and new password
  const [email, setEmail] = useState('');
  const [resetCode, setResetCode] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const navigate = useNavigate();

  // Handle requesting a reset code
  const handleRequestResetCode = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL || 'https://api.eatourshorts.com'}/password-reset/request`, { email });
      setSuccess(response.data.message);
      setStep(2); // Move to Step 2 after successfully requesting a reset code
    } catch (err) {
      setError(err.response?.data?.error || 'An error occurred. Please try again.');
    }
  };

  // Handle resetting the password
  const handlePasswordReset = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL || 'https://api.eatourshorts.com'}/password-reset/reset`, {
        reset_code: resetCode,
        new_password: newPassword,
      });
      setSuccess(response.data.message);
      setTimeout(() => navigate('/login'), 3000); // Redirect to login after 3 seconds
    } catch (err) {
      setError(err.response?.data?.error || 'An error occurred. Please try again.');
    }
  };

  return (
    <div
      style={{
        display: 'flex', // Flexbox for centering
        justifyContent: 'center', // Center horizontally
        alignItems: 'center', // Center vertically
        height: '100vh', // Full viewport height
        fontFamily: 'Arial, sans-serif',
        color: '#333',
        background: 'linear-gradient(to bottom, #f0f8ff, #d6eaff)', // Light gradient background
      }}
    >
      <div
        style={{
          maxWidth: '400px',
          width: '100%',
          padding: '20px',
          backgroundColor: '#ffffff', // White card background
          borderRadius: '10px',
          boxShadow: '0 8px 16px rgba(0, 0, 0, 0.2)', // Subtle shadow for depth
          alignItems: 'center', // Center horizontally
          textAlign: 'center', // Center text inside the card
        }}
      >
        {step === 1 && (
          <>
            <h1 style={{ color: '#007BFF', marginBottom: '20px', fontSize: '1.8rem' }}>
              Request Password Reset
            </h1>
            <form onSubmit={handleRequestResetCode}>
              <div style={{ marginBottom: '15px' }}>
                <label
                  htmlFor="email"
                  style={{
                    display: 'block',
                    marginBottom: '5px',
                    fontWeight: 'bold',
                    color: '#333',
                  }}
                >
                  Email Address
                </label>
                <input
                  type="email"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  style={{
                    width: '90%',
                    padding: '10px',
                    border: '1px solid #ccc',
                    borderRadius: '5px',
                    fontSize: '16px',
                    boxShadow: 'inset 0 2px 4px rgba(0, 0, 0, 0.1)',
                  }}
                />
              </div>
              <button
                type="submit"
                style={{
                  width: '100%',
                  padding: '12px',
                  backgroundColor: '#007BFF',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '5px',
                  fontSize: '16px',
                  cursor: 'pointer',
                  transition: 'background-color 0.3s',
                }}
                onMouseEnter={(e) => (e.target.style.backgroundColor = '#0056b3')}
                onMouseLeave={(e) => (e.target.style.backgroundColor = '#007BFF')}
              >
                Request Reset Code
              </button>
            </form>
          </>
        )}
  
        {step === 2 && (
          <>
            <h1 style={{ color: '#007BFF', marginBottom: '20px', fontSize: '1.8rem' }}>
              Reset Your Password
            </h1>
            <form onSubmit={handlePasswordReset}>
              <div style={{ marginBottom: '15px' }}>
                <label
                  htmlFor="resetCode"
                  style={{
                    display: 'block',
                    marginBottom: '5px',
                    fontWeight: 'bold',
                    color: '#333',
                  }}
                >
                  Reset Code
                </label>
                <input
                  type="text"
                  id="resetCode"
                  value={resetCode}
                  onChange={(e) => setResetCode(e.target.value)}
                  required
                  style={{
                    width: '100%',
                    padding: '10px',
                    border: '1px solid #ccc',
                    borderRadius: '5px',
                    fontSize: '16px',
                    boxShadow: 'inset 0 2px 4px rgba(0, 0, 0, 0.1)',
                  }}
                />
              </div>
              <div style={{ marginBottom: '15px' }}>
                <label
                  htmlFor="newPassword"
                  style={{
                    display: 'block',
                    marginBottom: '5px',
                    fontWeight: 'bold',
                    color: '#333',
                  }}
                >
                  New Password
                </label>
                <input
                  type="password"
                  id="newPassword"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  required
                  style={{
                    width: '100%',
                    padding: '10px',
                    border: '1px solid #ccc',
                    borderRadius: '5px',
                    fontSize: '16px',
                    boxShadow: 'inset 0 2px 4px rgba(0, 0, 0, 0.1)',
                  }}
                />
              </div>
              <button
                type="submit"
                style={{
                  width: '100%',
                  padding: '12px',
                  backgroundColor: '#007BFF',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '5px',
                  fontSize: '16px',
                  cursor: 'pointer',
                  transition: 'background-color 0.3s',
                }}
                onMouseEnter={(e) => (e.target.style.backgroundColor = '#0056b3')}
                onMouseLeave={(e) => (e.target.style.backgroundColor = '#007BFF')}
              >
                Reset Password
              </button>
            </form>
          </>
        )}
  
        {error && (
          <p
            style={{
              color: '#ff4500',
              marginTop: '15px',
              fontWeight: 'bold',
              textAlign: 'center',
            }}
          >
            {error}
          </p>
        )}
        {success && (
          <p
            style={{
              color: '#28a745',
              marginTop: '15px',
              fontWeight: 'bold',
              textAlign: 'center',
            }}
          >
            {success}
          </p>
        )}
      </div>
    </div>
  );
};
export default PasswordReset;